import { render, staticRenderFns } from "./SearchFilterTokens.vue?vue&type=template&id=9be47500&scoped=true&"
import script from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
import style0 from "./SearchFilterTokens.vue?vue&type=style&index=0&id=9be47500&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9be47500",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9be47500')) {
      api.createRecord('9be47500', component.options)
    } else {
      api.reload('9be47500', component.options)
    }
    module.hot.accept("./SearchFilterTokens.vue?vue&type=template&id=9be47500&scoped=true&", function () {
      api.rerender('9be47500', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2XqyWcGx3HwRz/JS/comp/SearchFilterTokens.vue"
export default component.exports